import { useTranslation } from 'next-i18next'

import { NAVIGATION_ICONS } from '@/constants/navigationAssets'

import { useIsTablet } from '@/utils/useIsTablet'

import CommonButton from '@/components/form/Button/CommonButton'

import BtnGlobalCustomStyles from '@/components/form/Button/button.customStyles'

import { useMarket } from '@/utils/multi-markets/context'

import NavipayAdvertisement from '../NavipayAdvertisement/NavipayAdvertisement'

import {
  FiltersWrapper,
  StyledImageMapWrapper,
  PinMarkerWrapper,
  StyledMiniMapImg,
  Divider
} from './Filters.styled'
import { FiltersProps } from './Filters.types'
import FiltersContent from './FiltersContent'

export default function Filters({
  options,
  removeOption,
  clearAllFilters,
  onMapModalOptn,
  handleAddRemoveService,
  selectedServices,
  handlePriceChangeComplete,
  radius,
  setRadius,
  currency,
  handleOverlayToggle
}: FiltersProps) {
  const { t } = useTranslation('parkings')
  const translatedMapButton = t('searchNearParking.filters.mapButton')
  const { isTablet } = useIsTablet()
  const { market } = useMarket()

  return (
    <FiltersWrapper data-test-id="filters-wrapper">
      <StyledImageMapWrapper
        onClick={onMapModalOptn}
        data-test-id="image-map-wrapper"
      >
        <StyledMiniMapImg
          src={NAVIGATION_ICONS.map}
          alt="map"
          width={isTablet ? 230 : 263}
          height={isTablet ? 114 : 140}
          loading="lazy"
        />
        <PinMarkerWrapper data-test-id="pin-marker-wrapper">
          <img
            src={NAVIGATION_ICONS.pinMiniMap}
            alt="Pin mini map"
            loading="lazy"
          />
        </PinMarkerWrapper>
        <CommonButton
          variant="searchWrapper"
          data-test-id="button-mini-map"
          customStyle={BtnGlobalCustomStyles.miniMap}
        >
          {translatedMapButton}
        </CommonButton>
      </StyledImageMapWrapper>
      <FiltersContent
        clearAllFilters={clearAllFilters}
        options={options}
        removeOption={removeOption}
        handleAddRemoveService={handleAddRemoveService}
        selectedServices={selectedServices}
        handlePriceChangeComplete={handlePriceChangeComplete}
        radius={radius}
        setRadius={setRadius}
        currency={currency}
        handleOverlayToggle={handleOverlayToggle}
      />

      {market !== 'pl' && (
        <>
          <Divider />
          <NavipayAdvertisement data-test-id="navipay-advertisement-content" />
        </>
      )}
    </FiltersWrapper>
  )
}
